import React, { useRef, useState } from 'react';

import useWindowSize from 'hooks/use-windowSize';

import { Radar } from "react-chartjs-2";

import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';

import RadarCchartImage140 from '@core/assets/images/radar-chart-140.png';
import RadarChartImage from '@core/assets/images/radar-chart-background.png';
import RadarChartReportImage from '@core/assets/images/radar-chart-report.png';
import RadarChartMobileImage from '@core/assets/images/radar-chart-mobile.png';


const RadarChartReport = ({ chartData, isSmall = false, imageSize = null }) => {
    const { mobileDevice } = useWindowSize();

    ChartJS.register(RadialLinearScale,
        PointElement,
        LineElement,
        Filler,
        Tooltip,
        Legend,
    );
    const RadarData = {
        labels: [["IT Solutions"], ["Quality", "Control"], ["Quality", "Assurance"],
        ["Supply Chain", "Management"], "Manufacturing", ["Regulatory", "Affairs"], ["Marketing", "and Sales"], ["Professional", "Development"]],
        datasets: [
            {
                // label: "March",
                strokeColor: "rgba(220,220,220,1)",
                // backgroundColor: "rgba(255, 106, 209, 0.30)",
                fill: false,
                lineWidth: 1,
                borderColor: "#65829F",
                pointBackgroundColor: "#65829F",
                poingBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(34, 202, 236, 1)",
                pointRadius: 1,
                data: [10, 10, 10, 10, 10, 10, 10, 10],
            },
            {
                // label: "March",
                strokeColor: "rgba(220,220,220,1)",
                backgroundColor: "rgba(255, 106, 209, 0.30)",
                borderColor: "#BB3A90",
                pointBackgroundColor: "#BB3A90",
                poingBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(34, 202, 236, 1)",
                pointRadius: 1.5,
                data: [
                    chartData?.it_solutions,
                    chartData?.quality_control,
                    chartData?.quality_assurance,
                    chartData?.supply_chain_management,
                    chartData?.manufacturing,
                    chartData?.regulatory_affairs,
                    chartData?.marketing_and_sales,
                    chartData?.professional_development
                ],
            },
        ]
    };

    const image = new Image();
    if (imageSize === null) {
        if (mobileDevice || isSmall) {
            image.src = RadarChartMobileImage.src;
        }
        else
            image.src = RadarChartReportImage.src;
    } else {
        image.src = RadarCchartImage140.src;
    }

    const plugin = {
        id: 'custom_canvas_background_image',
        beforeDraw: (chart) => {
            if (image.complete) {
                const ctx = chart.ctx;
                const { top, left, width, height } = chart.chartArea;
                const x = (left + width / 2 - image.width / 2);
                const y = top + height / 2 - image.height / 2;
                ctx.drawImage(image, x, y);
            } else {
                image.onload = () => chart.draw();
            }
        },
        afterLayout: chart => {
            chart.getDatasetMeta(0).rScale._pointLabelItems.forEach(o => o.textAlign = 'center');
        }
    };

    const RadarOptions = {

        scale: {
            min: -1,
            max: 10,
            // backdropColor: '#000',
            backdropSize: 20,
            strokeColor: "rgba(220,220,220,1)",
            // display: false,
            // backgroundColor: '#000',            
            ticks: {
                beginAtZero: true,
                stepSize: 2,
                display: false,
            },
        },
        scales: {
            r: {
                angleLines: {
                    display: false,
                    color: '#A8BCCC',
                    borderDash: [6, 5],
                    borderDashOffset: 100
                },
                grid: {
                    display: false,
                },
                pointLabels: {
                    color: ((c) => {
                        return '#403f3f';
                    }),
                    padding: mobileDevice || isSmall ? 27 : 40,
                    font: {
                        size: mobileDevice || isSmall ? 9 : 13,
                        weight: 500,
                        family: 'Montserrat',
                    },
                },
                ticks: {
                    display: false,
                }
            }
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: { enabled: false },
        },
        elements: {
            line: {
                borderWidth: 1
            }
        },
        animation: {
            duration: 0
        }

    };

    return (
        <div className='' style={{ position: 'relative', zIndex: 10 }}>
            <Radar
                data={RadarData}
                plugins={[plugin]}
                options={RadarOptions}
            />
        </div >
    );
};

export default RadarChartReport;